<template>
  <v-card
    class
    :style="getNotificacoesPopupCardStyle()"
    elevation="1"
    @click="markNotificationAsRead(id)"
  >
    <v-card-title>
      <h3>{{ getStatusText(tipo) }}</h3>
      <p>{{ mensagem }}</p>
    </v-card-title>

    <v-card-actions>
      <span class="left value">
        <strong>{{ referencia }}</strong>
      </span>
      <v-spacer></v-spacer>
      <span class="right">
        <span class="text--lighten-1" :style="getExpiresColor()">{{
          data | moment("DD MMM[, às ]HH:mm")
        }}</span>
      </span>
    </v-card-actions>
  </v-card>
</template>
<script lang="js">
import { getStatusText } from "@/libs/utils";
export default {
  name: "NotificacoesPopupCard",
  methods: {
    getNotificacoesPopupCardStyle() {
      let style = [];
      let t = this;
      style.push({ borderBottom: "2px solid" + t.color });
      if (t.removeBorderLeft) {
        style.push({ borderLeft: "none" });
      }
      if (t.removeBorderRight) {
        style.push({ borderRight: "none" });
      }

      let visualizadaStyle = !this.visualizada
        ? { backgroundColor: "rgba(242,245,245,0.8)" }
        : {};
      style.push(visualizadaStyle);

      return style;
    },
    getExpiresColor() {
      let style = [];
      let t = this;
      let value = t.expiresIn || t.willWait || false;
      if (!value) return;
      if (value < 7) {
        style.push({ color: "#F5A623" });
      }
      if (value < 5) {
        style.push({ color: "red" });
      }
      return style;
    },
    async markNotificationAsRead() {
      if (this.visualizada) return;
      let id = this.id;
      try {
        visualizada = await this.$store.dispatch("PATCH_NOTIFICATION_AS_READ", {
          id,
        });
      } catch (e) {
        console.warn(e);
      }
      this.$emit("viewNotification", id);
    },
  },
  data() {
    return {
      getStatusText
    };
  },
  mounted() {},
  props: [
    "id",
    "value",
    "expiresIn",
    "waitTime",
    "title",
    "visualizada",
    "finished",
    "color",
    "removeBorderLeft",
    "removeBorderRight",
    "actionRightText",
    "tipo",
    "referencia",
    "mensagem",
    "data",
  ],
};
</script>
<style lang="scss" scoped>
.v-card {
  border-bottom: 1px solid black;
  width: 100%;
  cursor: pointer;
  border-bottom: 1px solid #f1f1f1;
  transition: all 0.2s ease;

  h3 {
    font-size: 12px;
    font-weight: 900;
    line-height: 16px;
  }
  p {
    font-size: 12px;
    font-weight: 300;
    line-height: 17px;
    color: #7f7f7f;
  }
  i {
    color: red !important;
    font-size: 12px;
    margin-right: 5px;
  }
  &:hover {
    background-color: #eee;
  }
  .v-card__actions {
    padding: 25px;
    padding-top: 0;
    margin: 0;
    padding-bottom: 10px;
    .left {
      font-size: 12px;
      color: #1c1c1c;
      font-weight: 500;
      line-height: 16px;
    }
    .right {
      font-size: 12px;
      font-weight: 300;
      color: #b1b1b1;
      line-height: 16px;
    }
  }
  .v-card__title {
    padding: 15px;
    margin: 0;
    padding-bottom: 0;
  }
}
</style>


// WEBPACK FOOTER //
// ./src/components/NotificacoesPopupCard.vue